import { createApi } from '@reduxjs/toolkit/query/react'
import { NetWork } from '../../../common/apiKey'
import { DELETE, GET, PATCH, POST, PUT } from '../../../common/contants'
import { ReponseData2 } from '../../../types'
import { MaintenanceScheduleType } from '../../../types/maintenanceSchedule'
import { axiosBaseQuery } from '../../baseQuery'

export const maintenanceScheduleApi = createApi({
  reducerPath: 'maintenanceScheduleApi',
  baseQuery: axiosBaseQuery,
  tagTypes: ['MaintenanceSchedule'],
  endpoints: (builder) => ({
    getListMaintenanceSchedule: builder.query({
      query: (params) => ({
        url: NetWork.maintenanceSchedule,
        method: GET,
        params: params,
        providesTags: (result: ReponseData2<{ rows: MaintenanceScheduleType[] }>) =>
          result ? [{ type: 'MaintenanceSchedule', id: 'LIST' }] : []
      })
    }),
    getMaintenanceScheduleById: builder.query({
      query: (params: { maintenanceScheduleId: number }) => ({
        url: NetWork.maintenanceScheduleId(params.maintenanceScheduleId),
        method: GET
      })
    }),
    addMaintenanceSchedule: builder.mutation({
      query: (data) => ({
        url: NetWork.maintenanceSchedule,
        method: POST,
        data: data
      })
    }),
    updateMaintenanceSchedule: builder.mutation({
      query: (data) => ({
        url: NetWork.maintenanceScheduleId(data.id),
        method: PUT,
        data: data
      })
    }),
    deleteMaintenanceSchedule: builder.mutation({
      query: (data: { ids: Array<number | string> }) => ({
        url: NetWork.maintenanceSchedule,
        method: DELETE,
        data: data
        // invalidatesTags: [{ type: 'MaintenanceSchedule', id: 'LIST' }] // Vô hiệu hóa tag 'MaintenanceSchedule' với id 'LIST' để gọi lại getListMaintenanceSchedule
      })
    }),
    changeStatusMaintenanceSchedule: builder.mutation({
      query: (data: { maintenanceScheduleId: number; params: { isActive: boolean } }) => ({
        url: NetWork.maintenanceScheduleId(data.maintenanceScheduleId),
        method: PATCH,
        params: data.params
      })
    })
  })
})

// Export hooks for usage in functional components
export const {
  useGetListMaintenanceScheduleQuery,
  useDeleteMaintenanceScheduleMutation,
  useAddMaintenanceScheduleMutation,
  useGetMaintenanceScheduleByIdQuery,
  useUpdateMaintenanceScheduleMutation,
  useChangeStatusMaintenanceScheduleMutation
} = maintenanceScheduleApi
